// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map {
    width: 50%;
}

.search {
    position: absolute;
    top: 15px;
    z-index: 9999;
    right: 165px;
}

.open-arrow {
    position: absolute;
    background-color: #fff;
    padding: 5px 10px;
    border-radius: 0px 5px 5px 0px;
    z-index: 999;
    width: 30px;
    top: 40px;
    margin-left: -5px;
    line-height: 12px;
}

.open-arrow:hover {
    cursor: pointer;
    box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.25);
}

.open-arrow .material-icons {
    font-size: 15px;
}

.close-arrow {
    transform: rotate(180deg);
    padding: 5px 10px;
    background-color: #f6f6f6;
    margin-bottom: 0px;
    color: #003561;
}

.close-arrow:hover {
    cursor: pointer;
}

.layer-menu-siderbar {
    width: 350px;
    top: 55px !important;
    left: 10px;
    bottom: unset;
    min-height: max-content;
    overflow: hidden;
}

.mat-drawer-content {
    position: relative;
    z-index: 1;
    display: block;
    /* height: 100vh !important; */
    overflow: hidden !important;
    /* height: calc(100vh - 42px); */
}

.map-contentview {
    max-height: 350px;
    overflow: auto;
}

/* layer div style */

.layer-style-list .mat-list-item {
    border: 1px #eee solid;
    margin-bottom: -1px;
    font-size: 14px;
    font-family: 'Inter Regular';
    letter-spacing: 1px;
}

.layer-style-list .mat-list-item:hover {
    background-color: rgba(0, 0, 0, .04);
    cursor: pointer;
}

.layer-style-list.mat-list.mat-list-base {
    padding-top: 0px;
}

.layer-style-list .material-icons {
    font-size: 22px;
    color: #666;
    padding-right: 10px;
}

.layer-style-list ::ng-deep .mat-expansion-panel-body {
    padding: 0px 5px !important;
}

.layer-style-list ::ng-deep .mat-expansion-panel-spacing {
    margin: 0px !important;
}

.map-footer {
    position: absolute;
    bottom: 0px;
    width: 100%;
}

.layer-style-list img {
    width: 22px;
    height: 16px;
    padding-right: 7px;
}

.tool-icon {
    position: absolute;
    padding-top: 4px;
    text-align: right;
    right: 0px;
}

.tool-icon .material-icons {
    padding-top: 3px;
}

.edit-icon .material-icons {
    font-size: 18px;
    color: #666;
    border-radius: 25px;
    padding: 5px;
    background-color: #fefefe;
    border: 1px #f2f2f2 solid;
    margin-left: 5px;
}

.layers-name {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    max-width: 145px;
    margin-right: 5px;
    word-break: break-all;
}

.close-btn {
    text-align: right;
    margin-top: 8px;
    position: absolute;
    right: 20px;
}

.close-btn .material-icons {
    padding: 5px;
    border: 1px #ddd solid;
    border-radius: 50px;
    font-size: 18px;
    background-color: #fff;
}

::ng-deep .mat-drawer-backdrop.mat-drawer-shown {
    background-color: transparent !important;
}

.mat-toolbar-multiple-rows {
    min-height: 30px;
    border-bottom: 1px #eee solid;
}

.mat-toolbar-row,
.mat-toolbar-single-row {
    height: 30px;
    z-index: 2004;
}

/* .mat-drawer-container {
    height: calc(100vh - 91px) !important;
  } */

.mat-drawer {
    z-index: 2003;
}

.mat-card {
    font-family: 'Inter Regular';
    letter-spacing: 0.5px;
}

.mat-toolbar-row {
    padding: 0 10px !important;
}

.menu-spacer {
    flex: 1 1 auto;
}

.logo {
    height: 28px;

}

.mat-menu-panel {
    max-width: 500px !important;
    width: 370px !important;
    margin-left: 0px !important;
}

.mat-select-arrow {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid;
    /* margin: 0 4px; */
    float: right;
    position: absolute;
    right: 5px;
    top: 17px;
}

.nav-btn {
    padding-right: 20px;
    font-family: 'Inter Regular';
    color: #003561;
    letter-spacing: 1px;
}

#mobile-view {
    margin-top: 52px;
}

#mobile-view .nav-btn.mat-button {
    width: 100%;
    text-align: left;
}

.map-tool-siderbar {
    width: 40%;
}

::ng-deep .mat-form-field-appearance-outline .mat-form-field-infix {
    padding: 0.5em 0 1em 0 !important;
    font-size: 12px !important;
}

.layer-content {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 999;
    background-color: #fff;
    padding: 5px;
}

.map-title {
    float: left;
    width: 222px;
    background: rgba(255, 255, 255, 0.55);
    position: relative;
    padding: 2px 10px;
    font-family: 'Inter Regular';
    letter-spacing: 1px;
    color: #003561;
}

.map-name {
    max-width: 205px;
}

::ng-deep .mat-select-value,
::ng-deep .mat-form-field-label {
    font-size: 14px;
    font-family: Roboto, "Helvetica Neue", sans-serif !important;
    letter-spacing: 1px;
    color: #666;
}

.map-content {
    padding-bottom: 40px;
}

.nav-menu {
    display: inline;
}

.nav-menu .item-nav {
    float: left;
}

.nav-menu .close-btn {
    display: none;
}

@media (max-width: 768px) {
    .menu-icon {
        position: absolute;
        right: 10px;
    }

    .nav-menu .close-btn {
        display: block;
    }

    .close-btn {
        text-align: right;
        margin-top: 0px;
        position: absolute;
        right: 10px;
        top: 9px;
    }

    .close-btn .material-icons {
        padding: 5px;
        border: 1px #ddd solid;
        border-radius: 50px;
        background-color: #fff;
    }

    .nav-menu {
        display: none;
        top: 50px;
        position: fixed;
        background-color: #003561;
        width: 100%;
        height: 100%;
        left: 0px;
        padding: 15px 0px;
    }

    .nav-menu .item-nav {
        width: 100%;
        text-align: center;
    }

    .nav-menu .item-nav:hover {
        background-color: #1d66a3;
    }

    .nav-menu-m {
        display: inline-block !important;
    }

    .layer-content {
        width: 190px !important;
    }

    .map-title {
        width: 70px !important;
    }

    .layer-menu-siderbar {
        width: 200px !important;
    }

    ::ng-deep .mat-list-base .mat-list-item .mat-list-item-content,
    .mat-list-base .mat-list-option .mat-list-item-content {
        padding: 0 5px !important;
    }

    .layer-style-list .material-icons {
        font-size: 18px !important;
        padding-right: 4px !important;
    }

    /* .show-legeand-sidebar {
        bottom: 40px !important;
    } */
    :host ::ng-deep .show-legeand-sidebar {
        background: transparent !important;
    }

    .layers-name {
        max-width: 70px !important;
    }

    .layer-style-list img {
        width: 20px;
        height: 20px;
    }

}

[hidden] {
    display: none !important;
}

.shared-feature-btn {
    position: absolute;
    bottom: 0px;
    z-index: 999;
    margin-left: 40%;
}

@media (max-width: 400px) {
    .show-legeand-sidebar {
        width: 130px !important;
    }

    .map-tool-siderbar {
        width: 60%;
    }

    .show-legeand-sidebar {
        width: 130px !important;
    }
}

.layer_search_data {
    padding: 10px 5px;
    border: 1px #ddd solid;
    margin: 5px;
}

:host ::ng-deep .layer_name_overlay {
    margin: 10px 0 5px;
    color: #003561;
    font-weight: 500;
}

:host ::ng-deep ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

/* Track */
:host ::ng-deep ::-webkit-scrollbar-track {
    background: #f1f1f1;
}

/* Handle */
:host ::ng-deep ::-webkit-scrollbar-thumb {
    background: #003561;
    border-radius: 10px;
}

.info-box {
    background-color: #fff;
    padding: 10px;
    font-family: 'Inter Regular';
    transition: box-shadow 280ms cubic-bezier(.4, 0, .2, 1);
    border-radius: 4px;
    width: 244px !important;
    top: 0;
    height: calc(100vh - 55px);
    box-shadow: 3px 2px 5px 0px rgba(173, 173, 173, 1) !important;
}

.logo {
    cursor: pointer;
}

.info-box h4 {
    margin: 0px;
    line-height: 33px;
    font-family: 'Inter Regular';
    color: #003561;
    letter-spacing: 0.5px;
    border-bottom: 2px solid #fed11c;
    margin-bottom: 10px;
    font-weight: 500;
    padding-right: 10px;
}

.info-box .close-btn {
    top: -8px;
    right: 0px;
}

.details {
    position: relative;
}

.layer_name_overlay {
    margin: 0px;
    color: #003561;
    font-weight: 500;
}

:host ::ng-deep .mat-drawer-inner-container {
    overflow: initial;
}

.close-btn {
    text-align: right;
    font-size: 16px;
    margin-top: 7px;
    position: absolute;
    right: 10px;
    z-index: 999;
}

.close-btn .material-icons {
    padding: 5px;
    border: 1px #ddd solid;
    border-radius: 50px;
    background-color: #fff;
}

::ng-deep .ol-zoom {
    left: unset !important;
    right: 5px !important;
    top: 45px;
}

.deafultTemplate {
    /* height: calc(100vh); */
    /* height: calc(calc(100vh - 42px)); */
    width: 100%
}

.setMapHeight {
    height: calc(100vh - 42px) !important;
}

.templateDesignOne {
    height: calc(65vh);
}

.default-div {

    position: relative;
    border-right: 3px solid #003561;
    border-bottom: 3px solid #003561;
    height: calc(100vh - 90px);
}

.templateDesignTwo {
    /* height : 100vh !important; */
    width: calc(70vw);
}

.tem {
    width: calc(20vw);
    flex-grow: 100;

}

.drag-tb {
    right: 48% !important;
    bottom: -18px !important;
    position: absolute;
    z-index: 9999;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 100px;
    padding: 0px 4px;
    text-align: center;
    line-height: 30px;
    box-shadow: 3px 3px 3px 0px rgba(199, 199, 199, 1);
}

[mwlResizable] {
    box-sizing: border-box;
}

.search-container {
    margin-left: 12px;
}

.search-container a {
    background: #003561;
    width: 44px;
    height: 39px;
    color: #fff;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}

.search {
    vertical-align: bottom;
}

.search-container input {
    height: 39px;
    width: 250px;
    border: none;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}

.maptools {
    position: absolute;
    top: 12px;
    left: 376px;
    z-index: 999;
}

.map_menu {
    position: absolute;
    top: 15px;
    z-index: 1;
    right: 60px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 5px;
}

.map_menu ul {
    margin: 0px;
    padding-left: 0px;
    border: 1px #ddd solid;
    border-radius: 5px;
}

.map_menu ul li {
    display: inline;
    text-align: center;
    cursor: pointer;
}

.map_menu ul li:hover {
    background: rgba(255, 255, 255, 1);
}

.map_menu ul li:hover .mat-icon {
    color: #003561;
}

.map_menu ul li .mat-icon {
    line-height: 24px;
    font-size: 16px;
    border-right: 1px #ddd solid;
}

.searchCloseButton {
    float: right;
    font-size: 23px;
    color: #003561;
    margin-top: -24px;
    margin-right: -25px;
    cursor: pointer;
}


.print-box {
    position: absolute;
    background-color: #fff;
    right: 10px;
    top: 47px;
    width: 380px;
    padding: 10px 10px 10px 20px;
    border-radius: 5px;
    box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%);
}

.print-box p {
    margin: 0px;
    padding-top: 9px;
    font-size: 14px;
    letter-spacing: 0.5px;
    font-family: 'Inter Regular';
}

.mat-form-field {
    width: 100%;
}

.print-box ::ng-deep .mat-form-field-appearance-outline .mat-form-field-infix {
    padding: 0.2em 0 0.2em 0;
    font-size: 14px;
}

.print-box ::ng-deep .mat-form-field-wrapper {
    padding-bottom: 0.2em;
}

.print-box ::ng-deep .mat-form-field-label-wrapper {
    top: -1.5em;
}

.print-box ::ng-deep .mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {
    transform: translateY(-1.0em) scale(0.75);
}

.print-box ::ng-deep .mat-select-arrow {
    margin: 0 0px;
}

.print-box .mat-raised-button {
    height: 30px;
    line-height: 30px;
    padding: 0px 6px;
    font-size: 13px;
    letter-spacing: 0.5px;
    margin-right: 5px;
}

.btnLoader :host ::ng-deep .mat-progress-spinner circle,
.mat-spinner circle {
    stroke: #fff;
}

::ng-deep .my-custom-tooltip {
    max-width: unset !important;
}




.visible-loader {
    margin: 0;
    padding: 0;
}

:host ::ng-deep .mapboxgl-ctrl-group {
    margin-bottom: 50px !important;
    margin-right: 13px !important;
    position: relative;
    z-index: 999;
}

::ng-deep .my-custom-tooltip {
    max-width: unset !important;
}

.mat-icon {
    vertical-align: middle;
}

.download-excelview {
    position: relative;
    line-height: 2.4;
    right: -8px;
    top: -1px;
}

.overlay {
    position: fixed;
    top: 51px;
    left: 50%;
    z-index: 99999;
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation : portrait) {
    .map-tool-siderbar {
        width: 72%;
    }

    .map_menu {
        top: 55px;
        right: 16px;

    }

    .search {
        top: 57px;
        right: 125px;
    }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation : portrait) {
    .logo {
        margin-left: 40px;
    }
}

.search_box {
    position: absolute;
    left: 360px;
}

.mat-toolbarhead {

    position: relative;
    border-right: 3px solid #003561;
    z-index: 2;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);


}

.tools-operation {
    position: absolute;
    width: 502px;
    left: 117px;
    right: 0px;
    top: 0px;
    margin: 0 auto;
    z-index: 999;
    background: #FFFFFF;
}

.sublayer-box {
    padding: 4px 4px 4px 4px;
    border-bottom: 1px solid #eee !important;
    height: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;


}

.sublayername {
    font-family: 'Inter Regular';
    font-size: 12px;
}

.group-icon {
    font-size: 18px;
    height: 18px;
    width: 18px;
}

.remove-shadow {
    box-shadow: none !important;
}

.sqr {
    padding: 7px;
    border-radius: 3px;
    margin-right: 5px;
}

.user-t {
    margin: 0;
    padding: 6px 5px;
    border-radius: 5px;
    display: flex;
    font-family: 'Inter';
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: #fff;
    font-size: 12px;
    margin-bottom: 2px;

}

.map-contents {
    margin-top: 60px;
}

.assign-userdiv {
    position: absolute;
    z-index: 999;
    left: 10px;
    bottom: 200px;
    font-family: 'Inter Regular';
    width: 345px;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}

/* .sharedeafultTemplate {
    height: calc(108vh - 99px) !important
} */

.shared {
    height: calc(100vh - 10px) !important;
}

:host ::ng-deep .show-legeand-sidebar {
    background: transparent !important;
}

:host ::ng-deep .mapboxgl-ctrl-bottom-left {
    bottom: 10px !important;
    left: 0px;
    z-index: 1;
}

:host ::ng-deep .show-legeand-sidebar {
    right: 10px !important;
}

.width-80 {
    width: 80%;
}

:host ::ng-deep .mat-menu-content:not(:empty) {
    padding-bottom: 0px !important;
}

.search-chart {
    position: relative;
    left: 17px;
    bottom: 6px;
}

.search-data {
    position: relative;
    top: 2px;
    left: 15px;
}

`, "",{"version":3,"sources":["webpack://./src/app/app-share-map-module/share-map/share-map.component.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,8BAA8B;IAC9B,YAAY;IACZ,WAAW;IACX,SAAS;IACT,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,8CAA8C;AAClD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,8BAA8B;IAC9B,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA,oBAAoB;;AAEpB;IACI,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;;IAEI,YAAY;IACZ,aAAa;AACjB;;AAEA;;KAEK;;AAEL;IACI,aAAa;AACjB;;AAEA;IACI,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;;AAEhB;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;IAC5B,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iCAAiC;IACjC,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,kBAAkB;IAClB,iBAAiB;IACjB,4BAA4B;IAC5B,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,4DAA4D;IAC5D,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,kBAAkB;QAClB,WAAW;QACX,QAAQ;IACZ;;IAEA;QACI,YAAY;QACZ,sBAAsB;QACtB,mBAAmB;QACnB,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,SAAS;QACT,eAAe;QACf,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,SAAS;QACT,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;;QAEI,yBAAyB;IAC7B;;IAEA;QACI,0BAA0B;QAC1B,6BAA6B;IACjC;;IAEA;;OAEG;IACH;QACI,kCAAkC;IACtC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;AAEJ;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA,UAAU;AACV;IACI,mBAAmB;AACvB;;AAEA,WAAW;AACX;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,4BAA4B;IAC5B,uDAAuD;IACvD,kBAAkB;IAClB,uBAAuB;IACvB,MAAM;IACN,0BAA0B;IAG1B,6DAA6D;AACjE;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,4BAA4B;IAC5B,cAAc;IACd,qBAAqB;IACrB,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,sCAAsC;IACtC;AACJ;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,+BAA+B;IAC/B,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;;AAElB;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,kBAAkB;IAClB,aAAa;IACb,oCAAoC;IACpC,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IAGjB,kDAAkD;AACtD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,iHAAiH;AACrH;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,iHAAiH;AACrH;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;AACnB;;;AAGA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,SAAS;IACT,YAAY;IACZ,4BAA4B;IAC5B,kBAAkB;IAClB,kHAAkH;AACtH;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;;;;AAKA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,eAAe;IACf,SAAS;IACT,SAAS;IACT,cAAc;AAClB;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,SAAS;QACT,WAAW;;IAEf;;IAEA;QACI,SAAS;QACT,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;;IAEI,kBAAkB;IAClB,+BAA+B;IAC/B,UAAU;IACV,iHAAiH;;;AAGrH;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,UAAU;IACV,QAAQ;IACR,cAAc;IACd,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,wCAAwC;IACxC,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;;;AAGpB;;AAEA;IACI,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;;AAEtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,4BAA4B;IAC5B,YAAY;IACZ,iHAAiH;AACrH;;AAEA;;GAEG;;AAEH;IACI,qCAAqC;AACzC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd","sourcesContent":[".map {\n    width: 50%;\n}\n\n.search {\n    position: absolute;\n    top: 15px;\n    z-index: 9999;\n    right: 165px;\n}\n\n.open-arrow {\n    position: absolute;\n    background-color: #fff;\n    padding: 5px 10px;\n    border-radius: 0px 5px 5px 0px;\n    z-index: 999;\n    width: 30px;\n    top: 40px;\n    margin-left: -5px;\n    line-height: 12px;\n}\n\n.open-arrow:hover {\n    cursor: pointer;\n    box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.25);\n}\n\n.open-arrow .material-icons {\n    font-size: 15px;\n}\n\n.close-arrow {\n    transform: rotate(180deg);\n    padding: 5px 10px;\n    background-color: #f6f6f6;\n    margin-bottom: 0px;\n    color: #003561;\n}\n\n.close-arrow:hover {\n    cursor: pointer;\n}\n\n.layer-menu-siderbar {\n    width: 350px;\n    top: 55px !important;\n    left: 10px;\n    bottom: unset;\n    min-height: max-content;\n    overflow: hidden;\n}\n\n.mat-drawer-content {\n    position: relative;\n    z-index: 1;\n    display: block;\n    /* height: 100vh !important; */\n    overflow: hidden !important;\n    /* height: calc(100vh - 42px); */\n}\n\n.map-contentview {\n    max-height: 350px;\n    overflow: auto;\n}\n\n/* layer div style */\n\n.layer-style-list .mat-list-item {\n    border: 1px #eee solid;\n    margin-bottom: -1px;\n    font-size: 14px;\n    font-family: 'Inter Regular';\n    letter-spacing: 1px;\n}\n\n.layer-style-list .mat-list-item:hover {\n    background-color: rgba(0, 0, 0, .04);\n    cursor: pointer;\n}\n\n.layer-style-list.mat-list.mat-list-base {\n    padding-top: 0px;\n}\n\n.layer-style-list .material-icons {\n    font-size: 22px;\n    color: #666;\n    padding-right: 10px;\n}\n\n.layer-style-list ::ng-deep .mat-expansion-panel-body {\n    padding: 0px 5px !important;\n}\n\n.layer-style-list ::ng-deep .mat-expansion-panel-spacing {\n    margin: 0px !important;\n}\n\n.map-footer {\n    position: absolute;\n    bottom: 0px;\n    width: 100%;\n}\n\n.layer-style-list img {\n    width: 22px;\n    height: 16px;\n    padding-right: 7px;\n}\n\n.tool-icon {\n    position: absolute;\n    padding-top: 4px;\n    text-align: right;\n    right: 0px;\n}\n\n.tool-icon .material-icons {\n    padding-top: 3px;\n}\n\n.edit-icon .material-icons {\n    font-size: 18px;\n    color: #666;\n    border-radius: 25px;\n    padding: 5px;\n    background-color: #fefefe;\n    border: 1px #f2f2f2 solid;\n    margin-left: 5px;\n}\n\n.layers-name {\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    max-width: 145px;\n    margin-right: 5px;\n    word-break: break-all;\n}\n\n.close-btn {\n    text-align: right;\n    margin-top: 8px;\n    position: absolute;\n    right: 20px;\n}\n\n.close-btn .material-icons {\n    padding: 5px;\n    border: 1px #ddd solid;\n    border-radius: 50px;\n    font-size: 18px;\n    background-color: #fff;\n}\n\n::ng-deep .mat-drawer-backdrop.mat-drawer-shown {\n    background-color: transparent !important;\n}\n\n.mat-toolbar-multiple-rows {\n    min-height: 30px;\n    border-bottom: 1px #eee solid;\n}\n\n.mat-toolbar-row,\n.mat-toolbar-single-row {\n    height: 30px;\n    z-index: 2004;\n}\n\n/* .mat-drawer-container {\n    height: calc(100vh - 91px) !important;\n  } */\n\n.mat-drawer {\n    z-index: 2003;\n}\n\n.mat-card {\n    font-family: 'Inter Regular';\n    letter-spacing: 0.5px;\n}\n\n.mat-toolbar-row {\n    padding: 0 10px !important;\n}\n\n.menu-spacer {\n    flex: 1 1 auto;\n}\n\n.logo {\n    height: 28px;\n\n}\n\n.mat-menu-panel {\n    max-width: 500px !important;\n    width: 370px !important;\n    margin-left: 0px !important;\n}\n\n.mat-select-arrow {\n    width: 0;\n    height: 0;\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    border-top: 5px solid;\n    /* margin: 0 4px; */\n    float: right;\n    position: absolute;\n    right: 5px;\n    top: 17px;\n}\n\n.nav-btn {\n    padding-right: 20px;\n    font-family: 'Inter Regular';\n    color: #003561;\n    letter-spacing: 1px;\n}\n\n#mobile-view {\n    margin-top: 52px;\n}\n\n#mobile-view .nav-btn.mat-button {\n    width: 100%;\n    text-align: left;\n}\n\n.map-tool-siderbar {\n    width: 40%;\n}\n\n::ng-deep .mat-form-field-appearance-outline .mat-form-field-infix {\n    padding: 0.5em 0 1em 0 !important;\n    font-size: 12px !important;\n}\n\n.layer-content {\n    position: absolute;\n    top: 10px;\n    left: 10px;\n    z-index: 999;\n    background-color: #fff;\n    padding: 5px;\n}\n\n.map-title {\n    float: left;\n    width: 222px;\n    background: rgba(255, 255, 255, 0.55);\n    position: relative;\n    padding: 2px 10px;\n    font-family: 'Inter Regular';\n    letter-spacing: 1px;\n    color: #003561;\n}\n\n.map-name {\n    max-width: 205px;\n}\n\n::ng-deep .mat-select-value,\n::ng-deep .mat-form-field-label {\n    font-size: 14px;\n    font-family: Roboto, \"Helvetica Neue\", sans-serif !important;\n    letter-spacing: 1px;\n    color: #666;\n}\n\n.map-content {\n    padding-bottom: 40px;\n}\n\n.nav-menu {\n    display: inline;\n}\n\n.nav-menu .item-nav {\n    float: left;\n}\n\n.nav-menu .close-btn {\n    display: none;\n}\n\n@media (max-width: 768px) {\n    .menu-icon {\n        position: absolute;\n        right: 10px;\n    }\n\n    .nav-menu .close-btn {\n        display: block;\n    }\n\n    .close-btn {\n        text-align: right;\n        margin-top: 0px;\n        position: absolute;\n        right: 10px;\n        top: 9px;\n    }\n\n    .close-btn .material-icons {\n        padding: 5px;\n        border: 1px #ddd solid;\n        border-radius: 50px;\n        background-color: #fff;\n    }\n\n    .nav-menu {\n        display: none;\n        top: 50px;\n        position: fixed;\n        background-color: #003561;\n        width: 100%;\n        height: 100%;\n        left: 0px;\n        padding: 15px 0px;\n    }\n\n    .nav-menu .item-nav {\n        width: 100%;\n        text-align: center;\n    }\n\n    .nav-menu .item-nav:hover {\n        background-color: #1d66a3;\n    }\n\n    .nav-menu-m {\n        display: inline-block !important;\n    }\n\n    .layer-content {\n        width: 190px !important;\n    }\n\n    .map-title {\n        width: 70px !important;\n    }\n\n    .layer-menu-siderbar {\n        width: 200px !important;\n    }\n\n    ::ng-deep .mat-list-base .mat-list-item .mat-list-item-content,\n    .mat-list-base .mat-list-option .mat-list-item-content {\n        padding: 0 5px !important;\n    }\n\n    .layer-style-list .material-icons {\n        font-size: 18px !important;\n        padding-right: 4px !important;\n    }\n\n    /* .show-legeand-sidebar {\n        bottom: 40px !important;\n    } */\n    :host ::ng-deep .show-legeand-sidebar {\n        background: transparent !important;\n    }\n\n    .layers-name {\n        max-width: 70px !important;\n    }\n\n    .layer-style-list img {\n        width: 20px;\n        height: 20px;\n    }\n\n}\n\n[hidden] {\n    display: none !important;\n}\n\n.shared-feature-btn {\n    position: absolute;\n    bottom: 0px;\n    z-index: 999;\n    margin-left: 40%;\n}\n\n@media (max-width: 400px) {\n    .show-legeand-sidebar {\n        width: 130px !important;\n    }\n\n    .map-tool-siderbar {\n        width: 60%;\n    }\n\n    .show-legeand-sidebar {\n        width: 130px !important;\n    }\n}\n\n.layer_search_data {\n    padding: 10px 5px;\n    border: 1px #ddd solid;\n    margin: 5px;\n}\n\n:host ::ng-deep .layer_name_overlay {\n    margin: 10px 0 5px;\n    color: #003561;\n    font-weight: 500;\n}\n\n:host ::ng-deep ::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n}\n\n/* Track */\n:host ::ng-deep ::-webkit-scrollbar-track {\n    background: #f1f1f1;\n}\n\n/* Handle */\n:host ::ng-deep ::-webkit-scrollbar-thumb {\n    background: #003561;\n    border-radius: 10px;\n}\n\n.info-box {\n    background-color: #fff;\n    padding: 10px;\n    font-family: 'Inter Regular';\n    transition: box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\n    border-radius: 4px;\n    width: 244px !important;\n    top: 0;\n    height: calc(100vh - 55px);\n    -webkit-box-shadow: 3px 2px 5px 0px rgba(173, 173, 173, 1) !important;\n    -moz-box-shadow: 3px 2px 5px 0px rgba(173, 173, 173, 1) !important;\n    box-shadow: 3px 2px 5px 0px rgba(173, 173, 173, 1) !important;\n}\n\n.logo {\n    cursor: pointer;\n}\n\n.info-box h4 {\n    margin: 0px;\n    line-height: 33px;\n    font-family: 'Inter Regular';\n    color: #003561;\n    letter-spacing: 0.5px;\n    border-bottom: 2px solid #fed11c;\n    margin-bottom: 10px;\n    font-weight: 500;\n    padding-right: 10px;\n}\n\n.info-box .close-btn {\n    top: -8px;\n    right: 0px;\n}\n\n.details {\n    position: relative;\n}\n\n.layer_name_overlay {\n    margin: 0px;\n    color: #003561;\n    font-weight: 500;\n}\n\n:host ::ng-deep .mat-drawer-inner-container {\n    overflow: initial;\n}\n\n.close-btn {\n    text-align: right;\n    font-size: 16px;\n    margin-top: 7px;\n    position: absolute;\n    right: 10px;\n    z-index: 999;\n}\n\n.close-btn .material-icons {\n    padding: 5px;\n    border: 1px #ddd solid;\n    border-radius: 50px;\n    background-color: #fff;\n}\n\n::ng-deep .ol-zoom {\n    left: unset !important;\n    right: 5px !important;\n    top: 45px;\n}\n\n.deafultTemplate {\n    /* height: calc(100vh); */\n    /* height: calc(calc(100vh - 42px)); */\n    width: 100%\n}\n\n.setMapHeight {\n    height: calc(100vh - 42px) !important;\n}\n\n.templateDesignOne {\n    height: calc(65vh);\n}\n\n.default-div {\n\n    position: relative;\n    border-right: 3px solid #003561;\n    border-bottom: 3px solid #003561;\n    height: calc(100vh - 90px);\n}\n\n.templateDesignTwo {\n    /* height : 100vh !important; */\n    width: calc(70vw);\n}\n\n.tem {\n    width: calc(20vw);\n    flex-grow: 100;\n\n}\n\n.drag-tb {\n    right: 48% !important;\n    bottom: -18px !important;\n    position: absolute;\n    z-index: 9999;\n    background: rgba(255, 255, 255, 0.9);\n    border-radius: 100px;\n    padding: 0px 4px;\n    text-align: center;\n    line-height: 30px;\n    -webkit-box-shadow: 3px 3px 3px 0px rgba(199, 199, 199, 1);\n    -moz-box-shadow: 3px 3px 3px 0px rgba(199, 199, 199, 1);\n    box-shadow: 3px 3px 3px 0px rgba(199, 199, 199, 1);\n}\n\n[mwlResizable] {\n    box-sizing: border-box;\n}\n\n.search-container {\n    margin-left: 12px;\n}\n\n.search-container a {\n    background: #003561;\n    width: 44px;\n    height: 39px;\n    color: #fff;\n    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);\n}\n\n.search {\n    vertical-align: bottom;\n}\n\n.search-container input {\n    height: 39px;\n    width: 250px;\n    border: none;\n    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);\n}\n\n.maptools {\n    position: absolute;\n    top: 12px;\n    left: 376px;\n    z-index: 999;\n}\n\n.map_menu {\n    position: absolute;\n    top: 15px;\n    z-index: 1;\n    right: 60px;\n    background: rgba(255, 255, 255, 0.9);\n    border-radius: 5px;\n}\n\n.map_menu ul {\n    margin: 0px;\n    padding-left: 0px;\n    border: 1px #ddd solid;\n    border-radius: 5px;\n}\n\n.map_menu ul li {\n    display: inline;\n    text-align: center;\n    cursor: pointer;\n}\n\n.map_menu ul li:hover {\n    background: rgba(255, 255, 255, 1);\n}\n\n.map_menu ul li:hover .mat-icon {\n    color: #003561;\n}\n\n.map_menu ul li .mat-icon {\n    line-height: 24px;\n    font-size: 16px;\n    border-right: 1px #ddd solid;\n}\n\n.searchCloseButton {\n    float: right;\n    font-size: 23px;\n    color: #003561;\n    margin-top: -24px;\n    margin-right: -25px;\n    cursor: pointer;\n}\n\n\n.print-box {\n    position: absolute;\n    background-color: #fff;\n    right: 10px;\n    top: 47px;\n    width: 380px;\n    padding: 10px 10px 10px 20px;\n    border-radius: 5px;\n    box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%);\n}\n\n.print-box p {\n    margin: 0px;\n    padding-top: 9px;\n    font-size: 14px;\n    letter-spacing: 0.5px;\n    font-family: 'Inter Regular';\n}\n\n.mat-form-field {\n    width: 100%;\n}\n\n.print-box ::ng-deep .mat-form-field-appearance-outline .mat-form-field-infix {\n    padding: 0.2em 0 0.2em 0;\n    font-size: 14px;\n}\n\n.print-box ::ng-deep .mat-form-field-wrapper {\n    padding-bottom: 0.2em;\n}\n\n.print-box ::ng-deep .mat-form-field-label-wrapper {\n    top: -1.5em;\n}\n\n.print-box ::ng-deep .mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {\n    transform: translateY(-1.0em) scale(0.75);\n}\n\n.print-box ::ng-deep .mat-select-arrow {\n    margin: 0 0px;\n}\n\n.print-box .mat-raised-button {\n    height: 30px;\n    line-height: 30px;\n    padding: 0px 6px;\n    font-size: 13px;\n    letter-spacing: 0.5px;\n    margin-right: 5px;\n}\n\n.btnLoader :host ::ng-deep .mat-progress-spinner circle,\n.mat-spinner circle {\n    stroke: #fff;\n}\n\n::ng-deep .my-custom-tooltip {\n    max-width: unset !important;\n}\n\n\n\n\n.visible-loader {\n    margin: 0;\n    padding: 0;\n}\n\n:host ::ng-deep .mapboxgl-ctrl-group {\n    margin-bottom: 50px !important;\n    margin-right: 13px !important;\n    position: relative;\n    z-index: 999;\n}\n\n::ng-deep .my-custom-tooltip {\n    max-width: unset !important;\n}\n\n.mat-icon {\n    vertical-align: middle;\n}\n\n.download-excelview {\n    position: relative;\n    line-height: 2.4;\n    right: -8px;\n    top: -1px;\n}\n\n.overlay {\n    position: fixed;\n    top: 51px;\n    left: 50%;\n    z-index: 99999;\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation : portrait) {\n    .map-tool-siderbar {\n        width: 72%;\n    }\n\n    .map_menu {\n        top: 55px;\n        right: 16px;\n\n    }\n\n    .search {\n        top: 57px;\n        right: 125px;\n    }\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation : portrait) {\n    .logo {\n        margin-left: 40px;\n    }\n}\n\n.search_box {\n    position: absolute;\n    left: 360px;\n}\n\n.mat-toolbarhead {\n\n    position: relative;\n    border-right: 3px solid #003561;\n    z-index: 2;\n    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);\n\n\n}\n\n.tools-operation {\n    position: absolute;\n    width: 502px;\n    left: 117px;\n    right: 0px;\n    top: 0px;\n    margin: 0 auto;\n    z-index: 999;\n    background: #FFFFFF;\n}\n\n.sublayer-box {\n    padding: 4px 4px 4px 4px;\n    border-bottom: 1px solid #eee !important;\n    height: 24px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: #fff;\n\n\n}\n\n.sublayername {\n    font-family: 'Inter Regular';\n    font-size: 12px;\n}\n\n.group-icon {\n    font-size: 18px;\n    height: 18px;\n    width: 18px;\n}\n\n.remove-shadow {\n    box-shadow: none !important;\n}\n\n.sqr {\n    padding: 7px;\n    border-radius: 3px;\n    margin-right: 5px;\n}\n\n.user-t {\n    margin: 0;\n    padding: 6px 5px;\n    border-radius: 5px;\n    display: flex;\n    font-family: 'Inter';\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    background: #fff;\n    font-size: 12px;\n    margin-bottom: 2px;\n\n}\n\n.map-contents {\n    margin-top: 60px;\n}\n\n.assign-userdiv {\n    position: absolute;\n    z-index: 999;\n    left: 10px;\n    bottom: 200px;\n    font-family: 'Inter Regular';\n    width: 345px;\n    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);\n}\n\n/* .sharedeafultTemplate {\n    height: calc(108vh - 99px) !important\n} */\n\n.shared {\n    height: calc(100vh - 10px) !important;\n}\n\n:host ::ng-deep .show-legeand-sidebar {\n    background: transparent !important;\n}\n\n:host ::ng-deep .mapboxgl-ctrl-bottom-left {\n    bottom: 10px !important;\n    left: 0px;\n    z-index: 1;\n}\n\n:host ::ng-deep .show-legeand-sidebar {\n    right: 10px !important;\n}\n\n.width-80 {\n    width: 80%;\n}\n\n:host ::ng-deep .mat-menu-content:not(:empty) {\n    padding-bottom: 0px !important;\n}\n\n.search-chart {\n    position: relative;\n    left: 17px;\n    bottom: 6px;\n}\n\n.search-data {\n    position: relative;\n    top: 2px;\n    left: 15px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
